import { ReportLinkProps } from "ui"
import { twMerge } from "tailwind-merge"
import Link from "next/link"
import { ChartBarSquareIcon } from "@heroicons/react/24/outline"

export const ReportLink = ({ href, children, className }: ReportLinkProps) => {
  return (
    <div className={twMerge("flex flex-row items-start", className)}>
      <ChartBarSquareIcon className="mr-2 mt-0.5 h-5 w-5 shrink-0 stroke-gray-400" />
      <Link
        href={href}
        className="block text-sm leading-tight text-brand-green-dark hover:text-brand-green"
      >
        {children}
      </Link>
    </div>
  )
}
